<template>

<v-window v-model="step" vertical >

  <v-window-item >
    <v-card>
      <v-card-title class='subtitle-1 overline' >
      </v-card-title>
      <v-card-text>
        <v-text-field persistent-hint
          label='Username'
          v-model="username"
          v-bind="usernameAttrs"
          @input="usernameDirty"
          @keypress.enter.stop="validateUsername"
          :error-messages="usernameErrors"
          :loading="usernameReq.loading" />

        <v-alert text dense
          v-if="validUsername"
          type="success"
          class="caption" >

          <strong>Username is available</strong>
          <ul>
            <li>✓ Member can login with the username {{username}}</li>
            <li>✓ We will create a complimentary redirect email address for them {{username}}@appt.guru which redirects to their favorite email address</li>
            <li>✓ We will reserve the subdomain {{username}}.{{tld}} should they want to host a personal webpage here</li>
          </ul>

        </v-alert>
      </v-card-text>

      <v-card-actions >
        <v-spacer />
        <v-btn v-if="validUsername"
          @click="step=1"
          color="primary" >Next</v-btn>
        <v-btn v-else
          :loading="usernameReq.loading"
          @click="validateUsername" >Validate</v-btn>
      </v-card-actions>

    </v-card>
  </v-window-item >

  <v-window-item >
    <v-card>
      <request-status :request="emailReq" />
      <v-card-title >
        <v-btn @click="step--" :disabled="step===0" icon ><v-icon>mdi-chevron-left</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <strong>Username:</strong> {{username}} <v-btn @click="step--" v-if="step>0" x-small text >[change username]</v-btn>
        <v-text-field persistent-hint
          label='Work email'
          v-model="localEmail"
          v-bind="emailAttrs"
          @input="requests.validateEmail.status = 0"
          @keypress.enter.stop="validateEmail"
          :error-messages="emailErrors"
          :disabled="(usernameStatus !== 200)"
          :loading="emailReq.loading" />

        <template v-if="emailExists" >
          <v-alert text dense

            type="info"
            class="caption" >

            <strong>There is already an account with this email address.</strong><br/>
            <ul>
              <li>✓ We will create {{username}}@{{tld}} for you and forward email from {{username}}@{{tld}} to {{localEmail}}</li>
              <li>✓ This user will log in with {{username}} or {{username}}@{{tld}}</li>
            </ul>
          </v-alert>
          <v-checkbox
            v-model="iUnderstand"
            color="primary"
            class="primary--text"
            label="I have read the above and understand 👍" />
        </template>
      </v-card-text>
      <v-card-actions >
        <template v-if="emailExists && !iUnderstand" >
          Please verify that you have read the alert above by checking the checkbox
        </template>
        <v-spacer />

        <v-btn v-if="validEmail"
          @click="$emit('done')"
          :disabled="emailExists && !iUnderstand"
          color="primary" >Next
        </v-btn>
        <v-btn v-else
          :loading="emailReq.loading"
          @click="validateEmail" >Validate</v-btn>
      </v-card-actions>

    </v-card>
  </v-window-item>
</v-window>
  <!-- <request-status :request="requests.validateUsername" /> -->

  <!--<v-alert text dense type="warning" >
    That username is not available. Please try a different username
  </v-alert> -->

</template>
<script>
import Vue from 'vue'

export default {
  name: 'IdentityPicker',
  props: {
    value: { type: String, required: true },
    email: { type: String, required: true },
    redirectEmail: { type: String, required: true }
  },
  data () {
    return {
      step: 0,
      username: null,
      localEmail: null,
      iUnderstand: false,
      requests: {
        validateUsername: {
          resource: 'ag.team',
          extra: 'validate_username',
          method: 'post'
        },
        validateEmail: {
          resource: 'ag.team',
          extra: 'validate',
          method: 'post',
          status: 0
        }
      }
    }
  },
  mounted () {
    this.username = this.value
  },
  // watch: {
  //   username () {
  //     this.$emit('input', this.username)
  //   }
  // },
  methods: {
    validateUsername () {
      if (this.username && this.username.length > 0) {
        this.requests.validateUsername.data = {username: this.username}
        this.$request('save', this.requests.validateUsername)
      }
    },
     validateEmail () {
      if (this.localEmail && this.localEmail.length > 0) {
        this.requests.validateEmail.data = {email: this.localEmail}
        this.$request('save', this.requests.validateEmail)
      }
    },
    usernameDirty () {
      Vue.set(this.requests.validateUsername, 'status', 0)
    }
  },
  watch: {
    usernameStatus () {
      if (this.usernameStatus === 200) {
        this.$emit('input', this.username)
      } else {
        this.$emit('input', null)
      }
    },
    emailStatus () {
      if (this.emailExists) {
        let email = `${this.username}@appt.guru`
        this.$emit('update:email', email)
        this.$emit('update:redirectEmail', this.localEmail)
      } else {
        this.$emit('update:email', this.localEmail)
        this.$emit('update:redirectEmail', this.localEmail)
      }
    }
  },
  computed: {
    usernameReq () {
      return this.requests.validateUsername
    },
    usernameStatus () {
      return this.usernameReq.status
    },
    usernameAvailable () {
      return (this.usernameStatus === 200)
    },
    usernameErrors () {
      return this.getObjectPath(this.usernameReq, 'errors.username', [])
    },
    usernameAttrs () {
      if (this.usernameStatus === 200) {
        return {
          'color': 'success',
          'appendIcon': 'mdi-check',
          hint: 'Valid username'
        }
      }
      return {
        hint: 'Choose a unique username for this user'
      }
    },
    validUsername () {
      return (this.usernameStatus === 200)
    },
    emailReq () {
      return this.requests.validateEmail
    },
    emailReqResult () {
      return this.emailReq.result
    },
    emailStatus () {
      return this.emailReq.status
    },
    emailErrors () {
      return this.getObjectPath(this.emailReq, 'errors.email', [])
    },
    emailAvailable () {
      return (this.emailStatus === 200)
    },
    emailExists () {
      if (this.emailStatus === 200 && this.emailReq.result.exists === true) { return true }
      if (this.emailStatus === 200 && this.emailReq.result.exists === false) { return false }
      return null
    },
    emailValue () {
      return this.emailReqResult
    },
    validEmail () {
      return (this.emailStatus === 200)
    },
    emailAttrs () {
      if (this.validEmail) {
        return {
          'color': 'success',
          'appendIcon': 'mdi-check',
          hint: 'Valid email',
        }
      }
      return {
        hint: 'Provide this user\'s professional work email address'
      }
    }
  }
}
</script>
